export default defineNuxtRouteMiddleware(() => {
	const userAgent = useRequestHeaders()['user-agent'] || navigator.userAgent

	if (userAgent.includes('Google-InspectionTool') || userAgent.includes('Googlebot')) {
		console.log('Google Inspect Tool detected, disabling features...')

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		useState('isGoogleInspect', () => true)
	}
})
